import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function ProductCard({ product, className = "", eager = false }) {
  return (
    <Link
      to={product.slug === "shutters" ? "/shutters" : `/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className={`group relative flex flex-col overflow-hidden rounded-2xl border border-warm-200 bg-white shadow-sm transition-all duration-300 hover:shadow-xl hover:border-navy-800/20 ${className}`}
    >
      <div className="relative overflow-hidden aspect-[4/3]">
        <img
          src={product.image}
          alt={`Made-to-measure ${product.name.toLowerCase()} fitted in a Birmingham home`}
          loading={eager ? "eager" : "lazy"}
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-950/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="font-serif text-xl sm:text-2xl text-slate-900 mb-2">
          {product.name}
        </h3>
        <p className="text-sm leading-relaxed text-slate-600 flex-1">
          {product.short}
        </p>
        <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-navy-900">
          Explore {product.name}
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}
